// assets
import { IconCoin } from '@tabler/icons';
import CoinAoneDark from '../assets/images/CoinAoneDark';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CampaignIcon from '@mui/icons-material/Campaign';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';
import { IconMessage } from '@tabler/icons';
// constant
const icons = {
    IconCoin,
    CoinAoneDark,
    SummarizeIcon,
    CardGiftcardIcon,
    CampaignIcon,
    CreditCardIcon,
    SubdirectoryArrowLeftIcon,
    IconMessage
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

function children() {
    const children = [];
    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('61')) {
            children.push({
                id: 'changerequestapproval',
                title: 'Change Request',
                type: 'item',
                url: '/admin/changerequest',
                target: false,
                icon: icons.IconMessage
            });
        }

        // if (Roles.includes('61')) {
        //     children.push({
        //         id: 'aonewallet',
        //         title: 'Aone Wallet Controller',
        //         type: 'item',
        //         url: '/financial/aonewallet',
        //         target: false,
        //         icon: icons.CoinAoneDark
        //     });
        //     children.push({
        //         id: 'aonewalletHistory',
        //         title: 'AoneWallet History',
        //         type: 'item',
        //         url: '/financial/aonewallet/history',
        //         target: false,
        //         icon: icons.SummarizeIcon
        //     });
        //     children.push({
        //         id: 'aonewalletHistory',
        //         title: 'Credit Requirement',
        //         type: 'item',
        //         url: '/financial/aonewallet/credit',
        //         target: false,
        //         icon: icons.CardGiftcardIcon
        //     });
        // }
    }
    return children;
}
const approval = {
    id: 'admin',
    title: 'Admin',
    type: 'group',
    children: children()
};

export default approval;
